import { RootStoreType } from '@trivie/core'
import { addMiddleware, IMiddlewareEvent } from 'mobx-state-tree'
import * as Sentry from '@sentry/react'

const handleMagicLinkEval = (error: string, msg: string) => {
  localStorage.setItem(
    'ml-error',
    JSON.stringify({
      error,
      msg,
    }),
  )
}

interface StatusCodeHandlerProps {
  rootStore: RootStoreType | undefined
  showAlert: (title: string, message: string, reset?: boolean) => void
}

export const useStatusCodeMiddleware = (props: StatusCodeHandlerProps) => {
  const { rootStore, showAlert } = props
  const statusCodeMiddleware = (
    call: IMiddlewareEvent,
    next: (call: IMiddlewareEvent, callback?: (value: any) => any) => void,
  ) => {
    if (call.type === 'flow_resume_error') {
      const problem = call.args[0]
      switch (problem && problem.kind) {
        case 'unauthorized':
          switch (call.parentEvent?.name) {
            case 'evaluateMagicLink':
              handleMagicLinkEval(
                'Unauthorized',
                'Your magic link has expired, but you can request a new one.',
              )
              return next(call)
            default:
              return next(call)
          }
        case 'forbidden':
          switch (call.parentEvent?.name) {
            case 'evaluateMagicLink':
              handleMagicLinkEval(
                'Permission Error',
                "You don't have permission to login into this workspace as an administrator.",
              )
              return next(call)
            case 'startQuiz':
              return next(call)
            default:
              return next(call)
          }
        case 'rejected':
          switch (call.parentEvent?.name) {
            default:
              if (problem.message?.includes('Invalid access code')) {
                showAlert('Invalid Access Code', 'Workspace access code is invalid.', true)
              }
              return next(call)
          }
        case 'unprocessable-entity':
          Sentry.captureMessage(
            `422 - ${call.parentEvent?.name} - ${JSON.stringify(problem.message)}`,
          )
          switch (call.parentEvent?.name) {
            default:
              if (problem.message?.includes('Invalid access code')) {
                showAlert('Invalid Access Code', 'Workspace access code is invalid.', true)
              }
              return next(call)
          }
        default:
          return next(call)
      }
    }
    return next(call)
  }

  if (rootStore) {
    addMiddleware(rootStore, statusCodeMiddleware)
  }
}
